module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "step__container"
  }, [_c('div', {
    ref: "welcome",
    staticClass: "step__welcome"
  }, [_c('p', [_vm._v("Welcome to the family!")])]), _vm._v(" "), _c('div', {
    ref: "title",
    staticClass: "step__title"
  }, [_c('p', [_vm._v("Click the Download button below or search for us on the App Store. Log in with your account.")])]), _vm._v(" "), _c('div', {
    ref: "subtitle",
    staticClass: "step__subtitle"
  }, [_c('p', [_vm._v("If you need any help at all just email us at help@ohanaisfamily.com or call us at (240) 543-2074")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://ohanaisfamily.com/download"
    }
  }, [_c('downloadButton', {
    staticStyle: {
      "width": "15em",
      "display": "block",
      "margin-left": "auto",
      "margin-right": "auto",
      "margin-top": "4em"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "step__button"
  }, [_c('button', {
    ref: "button",
    staticClass: "button",
    on: {
      "click": _vm.goNextStep
    }
  }, [_c('span', [_vm._v("Back to home")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd521c52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/2-blocks/Step8_Welcome.vue
// module id = 549
// module chunks = 1